import React from 'react'

const Motives = () => {
    return (
        <div className="container motives"><div className="row">
            <div className="col-12">    <div>
                <h3>Chennai Nanbargal Nala Mandram – Motives:</h3>
                <ul><li>Education and Job Guide to Poor Family Students of our Society.</li>
                    <li>To develop online Matrimony Service to help our Society Peoples.</li>
                    <li>Awareness given to Students for Development in Education.</li>
                    <li>Approach to our society Govt. Officers (in service) for Development of Education to Poor Family Students.   </li>
                    <li>Further development in TNPSC Competitive Exams in Free Coaching for our Society Students (Like Projector Screen Coaching, Online Coaching, Video Conference Coaching, etc.).</li>

                    <li>To Honour our Society Officers in High Posts and High-level Business People.</li>

                    <li>10th & 12th Std. Students who are score high marks to honour (Like Shield, Award Certificate, and financial help) every year in GB Meeting functions. Our Mandram doing help to Poor Family students to Develop in Education without Political Involvement.</li> </ul>

                <h3>Chennai Nanbargal Nala Mandram – President and Secretary from 1985 onwards upto till Date</h3>



                <table >
                    <tr>
                        <th>Year</th>
                        <th>President</th>
                        <th>Secretary</th>
                    </tr>
                    <tr>
                        <td>1985-1986</td>
                        <td>Thiru.T.P. Kandasamy	</td>
                        <td>Thiru.T. Arunachalam</td>
                    </tr>
                    <tr>
                        <td>1986-1987</td>
                        <td>Thiru.T. Arunachalam	</td>
                        <td>Thiru.K. Rathinam…</td>
                    </tr>
                    <tr>
                        <td>01.10.2022-18.02.2022</td>
                        <td>Thiru.P. Krishnasamy	</td>
                        <td>Thiru.K. Annamalai</td>
                    </tr>
                    <tr>
                        <td>18.02.2022-…</td>
                        <td>Thiru.G. Palani</td>
                        <td>Thiru.R. Palani</td>
                    </tr>
                </table>

                <h3>Mandra Madal – Memories:</h3>
                <p>Thiru.K. Ponnusamy. I.A.S., Thiru.T.V. Kabali. M.A. and Thiru. Durai Ramanujam are taking efforts to published first “Mandra Madal” Magazine at the time of 9th Annual Day Celebration on 18.06.1994 and continuing publish till date with very good appreciation.</p>
                <p>Afterwards so Many Developments, Modifications, Designing colourfully and Beautifully Printed now.   </p>

                <h3>Mandra Madal – Editor & Publishers List - From July 1994 Onwards</h3>


                <table>
                    <tr>
                        <th>Editor</th>
                        <th>Publiser</th>

                    </tr>
                    <tr>
                        <td>Thiru. Aanivari Anandan</td>
                        <td>Thiru.C.V. Balasundaram</td>

                    </tr>
                    <tr>
                        <td>Thriu. R. Annal	</td>
                        <td>Thiru. R. Ramanujam</td>

                    </tr>

                </table>

            </div>
            </div></div></div>



    )
}

export default Motives
